import { useDispatch, useSelector } from 'react-redux';
import { checkoutMutationInProgress } from '../components/form/actions';
import { FETCH_CHECKOUT } from '../components/form/actions-constants';
import { selectIsEmvPayment } from '../selectors';
import { useCheckoutMapper } from './use-checkout-mapper';
import { useDeliveryBridge } from './use-delivery-bridge';
import { useEmvPaymentDevice } from './use-emv-payment-device';
import { usePurchaseMutation } from './use-purchase-mutation';
import type { EmvTransaction } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-types';

export const useModernCheckout = () => {
  const dispatch = useDispatch();
  const isEmvPayment = useSelector(selectIsEmvPayment);

  const { mapToPurchaseRequest } = useCheckoutMapper();
  const { purchase } = usePurchaseMutation();
  const { deliver } = useDeliveryBridge(); // TODO replace by modern delivery apollo custom hook
  const paymentDevice = useEmvPaymentDevice();

  const checkout = async () => {
    dispatch({ type: FETCH_CHECKOUT.LOADING });
    let emvPayment: EmvTransaction | undefined;

    if (isEmvPayment) {
      paymentDevice.startEmvTransaction();
      const result = await paymentDevice.waitForEmvTransactionCompletion();

      if (result.status === 'SUCCESS') {
        emvPayment = result.emvTransaction;
      } else {
        // error was handled inside emvPaymentModule
        return;
      }
    }

    dispatch(checkoutMutationInProgress(true));

    const request = mapToPurchaseRequest(emvPayment);
    const result = await purchase(request);

    if (result.data?.purchase?.__typename === 'OrderWithAccountCreated') {
      deliver(result.data.purchase);
    }
    if (result.data?.purchase?.__typename === 'PurchaseFailed') {
      // TODO handle purchase error in next MR
    }
  };

  return { checkout };
};
